module.exports = __webpack_public_path__ + "img/MemeETC (3).35e1f257.jpeg";